import { useOpen, useBlobUrl } from "../../../../../../../libs/hooks";
import { useWorkflowStoreEmptyZero } from "../../../../../store";
import { Grid } from "@mui/material";
import { OnlyPhoto } from "../../../../../../../libs/shared";

export const PackSellos = ({ widthFull }: { widthFull: string }) => {
  return (
    <Grid
      container
      justifyContent="flex-start"
      alignContent="flex-start"
      alignItems="flex-start"
      spacing={0}
      sx={{ bgcolor: "white", pt: 1 }}
    >
      <PhotoEtiquetaVentolerasAdicional1 widthFull={widthFull} />
      <PhotoEtiquetaVentolerasAdicional2 widthFull={widthFull} />
    </Grid>
  );
};

const PhotoEtiquetaVentolerasAdicional1 = ({
  widthFull,
}: {
  widthFull: string;
}) => {
  const {
    open: openMaEtVenAd1,
    handleClose: handleCloseMaEtVenAd1,
    handleOpen: handleOpenMaEtVenAd1,
  } = useOpen();

  const macroEtiquetasVentolerasAdicionalPhoto1 = useWorkflowStoreEmptyZero(
    (state) => state.macroEtiquetasVentolerasAdicionalPhoto1
  );

  const setMacroEtiquetasVentolerasAdicionalPhoto1 = useWorkflowStoreEmptyZero(
    (state) => state.setMacroEtiquetasVentolerasAdicionalPhoto1
  );
  const fotoUrl = useBlobUrl(macroEtiquetasVentolerasAdicionalPhoto1);

  return (
    <Grid
      item
      xs={12}
      sm={6}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseMaEtVenAd1}
        handleOpen={handleOpenMaEtVenAd1}
        label="SELLOS VACÍOS"
        open={openMaEtVenAd1}
        setFoto={setMacroEtiquetasVentolerasAdicionalPhoto1}
        width={widthFull === "xs" ? 180 : 130}
        fontSize={widthFull === "xs" ? 9 : 10}
      />
    </Grid>
  );
};

const PhotoEtiquetaVentolerasAdicional2 = ({
  widthFull,
}: {
  widthFull: string;
}) => {
  const {
    open: openMaEtVenAd2,
    handleClose: handleCloseMaEtVenAd2,
    handleOpen: handleOpenMaEtVenAd2,
  } = useOpen();

  const macroEtiquetasVentolerasAdicionalPhoto2 = useWorkflowStoreEmptyZero(
    (state) => state.macroEtiquetasVentolerasAdicionalPhoto2
  );

  const setMacroEtiquetasVentolerasAdicionalPhoto2 = useWorkflowStoreEmptyZero(
    (state) => state.setMacroEtiquetasVentolerasAdicionalPhoto2
  );
  const fotoUrl = useBlobUrl(macroEtiquetasVentolerasAdicionalPhoto2);

  return (
    <Grid
      item
      xs={12}
      sm={6}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseMaEtVenAd2}
        handleOpen={handleOpenMaEtVenAd2}
        label="SELLOS FULL"
        open={openMaEtVenAd2}
        setFoto={setMacroEtiquetasVentolerasAdicionalPhoto2}
        width={widthFull === "xs" ? 180 : 130}
        fontSize={widthFull === "xs" ? 9 : 10}
      />
    </Grid>
  );
};
